/**
 * ScrollArea Component
 *
 * A scrollable area with custom scrollbar styling
 */

import * as React from 'react';
import { cn } from '@/shared/lib/utils';

interface ScrollAreaProps extends React.HTMLAttributes<HTMLDivElement> {
  readonly orientation?: 'vertical' | 'horizontal' | 'both';
}

const ScrollArea = React.forwardRef<HTMLDivElement, ScrollAreaProps>(
  ({ className, children, orientation = 'vertical', ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'relative',
          orientation === 'vertical' && 'overflow-y-auto overflow-x-hidden',
          orientation === 'horizontal' && 'overflow-x-auto overflow-y-hidden',
          orientation === 'both' && 'overflow-auto',
          // Custom scrollbar styling using theme colors
          '[&::-webkit-scrollbar]:w-2',
          '[&::-webkit-scrollbar-track]:rounded-full',
          '[&::-webkit-scrollbar-track]:bg-muted',
          '[&::-webkit-scrollbar-thumb]:rounded-full',
          '[&::-webkit-scrollbar-thumb]:bg-muted-foreground/30',
          '[&::-webkit-scrollbar-thumb:hover]:bg-muted-foreground/50',
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);

ScrollArea.displayName = 'ScrollArea';

export { ScrollArea };
export type { ScrollAreaProps };
